import { useTranslation } from "react-i18next";
import React from "react";
import { useNavigate } from "react-router-dom";

const TicketBookingSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="mt-[10.25rem] flex flex-row items-center justify-center rounded-[0.9375rem] border border-[#DCDCDC] p-16 shadow-sm">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="24" cy="24" r="20" fill="#24C56E" />
          <path
            d="M17 24L22 29L31 19"
            stroke="white"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <div className="ml-5">
          <h1 className="text-[1.875rem] font-semibold leading-[2.5rem] text-[#232323]">
            {t("Your tour was submitted successfully!")}
          </h1>
          <span className="text-base font-normal leading-[1.375rem] text-[#232323]">
            {t("Booking details have been sent to:")}
            <span className="font-semibold"> test123@gmail.com</span>
          </span>
        </div>
        {/* Divider */}
        <div className="ml-[10rem] h-[5.875rem] w-[0.0625rem] bg-[#E0E0E0]" />

        {/* Booking Info */}
        <div className="ml-10 flex">
          <div className="space-y-4 text-[0.875rem] font-normal leading-[1.375rem] text-[#232323]">
            <p>{t("Book no")}</p>
            <p>{t("Book time")}</p>
            <p>{t("Status")}</p>
          </div>
          <div className="ml-10 space-y-4 text-[0.875rem] font-semibold leading-[1.375rem] text-[#232323]">
            <p>30925793202</p>
            <p>2024년 7월 11일 11:49</p>
            <p>{t("Pending")}</p>
          </div>
        </div>
      </div>
      <button
        className="mt-[6.25rem] rounded-[3.125rem] bg-black px-6 py-4 text-base font-semibold leading-[1.25rem] text-white"
        onClick={() => navigate("/mypage", { state: { activeTab: "booking" } })}
      >
        {t("My Booking")}
      </button>
    </div>
  );
};
export default TicketBookingSuccessPage;
